import { translatedPathRoute, TranslateRouterModule } from '@endeavour/ngx-translate-router'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'

import { Localization } from '@aa-app-localization'
import { PageService } from '@app-services'
import { PageComponent } from './page.component'
import { PageBuilderModule } from '@app-domains/page-builder/page-builder.module'
import { PipesModule } from '@app-pipes/pipes.module'
import { ProductListDomainModule } from '@app-domains/product-list/product-list-domain.module'

const routes = [
    translatedPathRoute('slug:slug', {
        component: PageComponent,
        slugKeyFactories: {
            slug: (injector, prevValue, prevLocale, nextLocale): string => {
                const service = injector.get(PageService)
                const identifier = service.getIdentifierFromSlug(prevValue)

                if (service.slugsTable) {
                    const entries = service.slugsTable[identifier]

                    if (! entries || entries.length === 0) {
                        return prevValue
                    }

                    const matchingEntry = entries.find(entry =>
                        entry[prevLocale as Localization.Locale]?.slug === prevValue,
                    )

                    const newSlug = matchingEntry
                        ? matchingEntry[nextLocale as Localization.Locale]?.slug
                        : null

                    return newSlug
                        ? newSlug
                        : prevValue
                }

                return prevValue
            },
        },
    }),
]

@NgModule({
    declarations: [
        PageComponent,
    ],
    imports: [
        PageBuilderModule,
        PipesModule,
        CommonModule,
        RouterModule.forChild(routes),
        TranslateRouterModule.forChild(routes),
        ProductListDomainModule,
    ],
})
export class PageModule {

}
